import ConfettiCelebration from "./ConfettiCelebration";
export default ConfettiCelebration;
